import { render, staticRenderFns } from "./AppSettingsTab.vue?vue&type=template&id=4f1778d8&scoped=true"
import script from "./AppSettingsTab.vue?vue&type=script&lang=js"
export * from "./AppSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./AppSettingsTab.vue?vue&type=style&index=0&id=4f1778d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1778d8",
  null
  
)

export default component.exports